import { z } from "zod";
import { playbookIdSchema } from "../entities/playbook.js";
import { teammateIdSchema } from "../entities/teammate.js";
const SELLING_STRATEGY_MAX_LENGTH = 5e4;
const sellingStrategySchema = z.string().max(SELLING_STRATEGY_MAX_LENGTH);
function checkUniqueIds(ids) {
  return new Set(ids).size === ids.length;
}
const uniquePlaybookIdsSchema = z.array(playbookIdSchema).refine(checkUniqueIds, "Duplicate playbook ids");
const funnelCreatePayloadSchema = z.object({
  voiceAgentTeammateIds: z.array(teammateIdSchema).refine(checkUniqueIds, "Duplicate voice agent ids"),
  playbookIds: uniquePlaybookIdsSchema,
  sellingStrategy: sellingStrategySchema
}).strict().refine(
  (payload) => payload.voiceAgentTeammateIds.length > 0 || payload.playbookIds.length === 1,
  "A funnel is about voice agents, or exactly one playbook"
);
const funnelUpdatePayloadSchema = z.object({
  sellingStrategy: sellingStrategySchema.optional(),
  playbookIds: uniquePlaybookIdsSchema.optional()
}).strict();
const funnelAggregatesQuerySchema = z.object({ voiceAgentTeammateId: teammateIdSchema.optional() }).strict();
const FUNNEL_BEFORE_FIRST_STAGE = "before-first-stage";
const funnelExamplesQuerySchema = z.object({
  momentKey: z.string().min(1),
  /** A stage key, or `FUNNEL_BEFORE_FIRST_STAGE`; any stage when absent. */
  stageKey: z.string().min(1).optional(),
  voiceAgentTeammateId: teammateIdSchema.optional()
}).strict();
const FUNNEL_IMPACT_FEW_INTERACTIONS = 10;
export {
  FUNNEL_BEFORE_FIRST_STAGE,
  FUNNEL_IMPACT_FEW_INTERACTIONS,
  SELLING_STRATEGY_MAX_LENGTH,
  funnelAggregatesQuerySchema,
  funnelCreatePayloadSchema,
  funnelExamplesQuerySchema,
  funnelUpdatePayloadSchema
};
//# sourceMappingURL=funnel.js.map
